import { render, staticRenderFns } from "./PopWrapper.vue?vue&type=template&id=cc967790"
import script from "./PopWrapper.vue?vue&type=script&lang=js"
export * from "./PopWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports